@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../app-brand/entities/entity-layer.module.less';

.container {
  display: flex;
  flex-direction: column;
}

.tooltip-content {
  text-align: center;
}

.graph-title {
  font-weight: @normal;
}

.legend {
  display: flex;
  justify-content: space-between;
}

.legend-color {
  width: 14px;
  height: 14px;
  display: inline-block;
  vertical-align: middle;
  margin: 0 4px 1px 0;
  border: 1px solid @insights-page--legend--border-color;
}

.legend-item {
  height: 20px;
}

.stacked-container {
  width: 100%;
  display: block;
  margin-bottom: 24px;
}
